import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { Helmet } from 'react-helmet';

import { useUserDetails } from '@/hooks';
import { domainCodeAtom, getDomainOptionLabel } from '@australiangreens/ag-internal-components';
import { Box, Container, Typography } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { AssignedListsTable } from './AssignedListsTable';
import { CoordinatorTable } from './CoordinatorListsTable';

export {
  ACCORDION_SUMMARY_STYLE,
  ALL_LISTS_TABLE_INITIAL_STATE,
  DEFAULT_TABLE_FILTER,
} from './listsPageTableState';

export default function ListsPage() {
  const { data: userDetails } = useUserDetails();
  const [listsTabSelection, setListsTabSelection] = useState('My lists');

  const domainCode = useAtomValue(domainCodeAtom);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>List Manager - Lists</title>
        <meta name="description" content="List Manager - Lists" />
      </Helmet>
      <Container
        sx={{
          maxWidth: '1500px !important',
          //       marginLeft: '6px',
          //       marginRight: '6px',
          padding: '2rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
        }}
      >
        <Typography component="h2" variant="h5">
          Lists
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <Tabs
            value={listsTabSelection}
            onChange={(_, newTabSelection) => {
              setListsTabSelection(newTabSelection);
            }}
          >
            <Tab label="My Lists" value={'My lists'} />
            {['Principal Coordinator'].includes(userDetails?.userLevel ?? 'None') && (
              <Tab label="All Lists" value={'All lists'} />
            )}
          </Tabs>

          {listsTabSelection === 'My lists' && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "2rem"
              }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1.5rem"
                }}>
                <Typography component="h3" variant="h6">
                  Caller assignments
                </Typography>
                <AssignedListsTable />
              </Box>
              {['Coordinator', 'Principal Coordinator'].includes(
                userDetails?.userLevel ?? 'None'
              ) && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1.5rem"
                  }}>
                  <Typography component="h3" variant="h6">
                    Coordinator assignments
                  </Typography>
                  <CoordinatorTable />
                </Box>
              )}
            </Box>
          )}
          {listsTabSelection === 'All lists' && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem"
              }}>
              <Typography component="h3" variant="h6">
                All lists in {getDomainOptionLabel(domainCode)}
              </Typography>
              <CoordinatorTable isPrincipalCoordinator />
            </Box>
          )}
        </Box>
      </Container>
    </>
  );
}
